<div class="form-group" [ngClass]="field.customClass" tabindex="0">
  <label class="mb-2">
    <span>{{ field.label }}</span>
    <span class="text-danger">{{ field.required ? '*' : '' }}</span>
  </label>
  <div class="d-flex gap-3">
    @for (opt of field.options; track opt.key) {
      <div class="form-check" [class.custom-control-inline]="field.inline">
        <input
          type="radio"
          class="btn-check"
          [id]="'opt' + field.name + opt.key"
          [name]="field.name"
          [value]="opt.key"
          [formControl]="formGroup | formControl: field.name"
          [attr.disabled]="disabled || null"
          autocomplete="off"
        />
        <label
          class="btn"
          [ngClass]="{
            'btn-secondary btn-selected':
              formGroup.get(field.name).value === opt.key,
            'btn-outline-secondary':
              formGroup.get(field.name).value !== opt.key,
          }"
          [for]="'opt' + field.name + opt.key"
        >
          {{ opt.value }}
        </label>
      </div>
    }
  </div>
</div>
@if (
  field.subFields &&
  field.subFields.length > 0 &&
  formGroup.value[field.name] === 'Yes'
) {
  <div class="row">
    @for (subfield of field.subFields; track subfield.name) {
      <app-dynamic-field
        [ngClass]="subfield | itemClass"
        [field]="subfield"
        [control]="formGroup | formControl: subfield.name"
        [disabled]="disabled"
        [customColumnTpls]="customColumnTpls"
        [markAsTouched]="markAsTouched"
      ></app-dynamic-field>
    }
  </div>
}
